if (typeof G == 'undefined') G = {};
G.Animations = G.Animations || {};

G.Animations.getMysteryGiftHeaderHide = function getMysteryGiftHeaderShow() {
  var onComplete = new Phaser.Signal;

  return { 
    animate: animate,
    onComplete: onComplete,
  };

  function animate(game, target) {
    var msg = G.Utils.find1stObjectWithName(target, "message");

    if (msg) {
      game.add.tween(msg)
        .to({y: -200}, 200, Phaser.Easing.Sinusoidal.In, true)
        .onComplete.add(onComplete.dispatch, onComplete);
    }
  }
}
